import { connect } from 'react-redux';
import React, { useEffect } from 'react';

import { IntercomProvider, useIntercom } from 'react-use-intercom';

import { getClientInfo } from '../../selectors/client';
import { openIntercomMessengerSession } from '../../services/intercomServices';

const INTERCOM_APP_ID = 'oegdlauk';

const IS_INTERCOM_ENABLED = process.env.NODE_ENV === 'production';

const mapStateToProps = (state) => ({
  user: state.baseReducer.user,
  client: getClientInfo(state.baseReducer.user),
});

const Container = connect(
  mapStateToProps,
  null,
)(({ user, client: { clientId }, children, isAuthenticated }) => {
  const { boot, shutdown } = useIntercom();

  const bootIdentifiedUser = async () => {
    let intercomUserJwt = null;

    try {
      ({ intercomUserJwt } = await openIntercomMessengerSession());
    } catch {
      // Keep the Messenger usable when the contact sync or the token generation fails.
    }

    boot({
      userId: user.id,
      name: `${user.firstName} ${user.lastName}`,
      email: user.email,
      intercomUserJwt,
      customAttributes: { client_id: clientId },
    });
  };

  useEffect(() => {
    if (!IS_INTERCOM_ENABLED) {
      return;
    }

    if (user?.id) {
      bootIdentifiedUser();
      return;
    }

    if (!isAuthenticated) {
      // Shutting down first avoids showing the previously logged user on the login page.
      shutdown();
      boot();
    }
  }, [user]);

  return <>{children}</>;
});

export const IntercomContainer = (props) => {
  const { children, isAuthenticated } = props;

  return (
    <IntercomProvider appId={INTERCOM_APP_ID}>
      <Container isAuthenticated={isAuthenticated}>{children}</Container>
    </IntercomProvider>
  );
};

export default IntercomContainer;
